import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in access new member */
const ManageAccessNewMemberScheme = Yup.object().shape({
    email: Yup.string()
        .email('Invalid Company email')
        .required('Company email is required')
        .max(256, 'Company Email can have a maximum of 256 characters'),
    roles: Yup.array()
        .test('atLeastOne', 'One of input must be selected', (item) =>
            item ? item.some((el) => el === true) : false
        )
        .required('Roles need to be inputed'),
    firstname: Yup.string()
        .required('First name is required')
        .max(256, 'First name can have a maximum of 256 characters'),
    middlename: Yup.string()
        .required('Middle name is required')
        .max(256, 'Middle name can have a maximum of 256 characters'),
    lastname: Yup.string()
        .required('Last name is required')
        .max(256, 'Last name can have a maximum of 256 characters'),
});
/** @constant {ObjectShape} - Yup Object used for validationScheme in access editing member */
const ManageAccessEditMemberScheme = Yup.object().shape({
    email: Yup.string()
        .email('Invalid Company email')
        .required('Company email is required')
        .max(256, 'Company Email can have a maximum of 256 characters'),
    status: Yup.array()
        .test('atLeastOne', 'One of input must be selected', (item) =>
            item ? item.some((el) => el === true) : false
        )
        .required('Status need to be inputed'),
});
export { ManageAccessNewMemberScheme, ManageAccessEditMemberScheme };
